import * as React from "react";
import type { VariantProps } from "class-variance-authority";
import {
    Button as BaseButton,
    buttonVariants as baseButtonVariants,
} from "@unreserved/ui/components/button";
import { cn } from "@unreserved/utils";

// Custom variant 
const customVariantOverrides = {
    outline: "border bg-transparent shadow-xs hover:bg-transparent hover:text-current dark:bg-transparent dark:border-input dark:hover:bg-transparent dark:hover:text-current",
    ghost: "bg-transparent hover:bg-transparent hover:text-current dark:bg-transparent dark:hover:bg-transparent dark:hover:text-current",
} as const;

interface ButtonProps
    extends React.ComponentProps<typeof BaseButton>,
    VariantProps<typeof baseButtonVariants> { }

function Button({ className, variant, size, ...props }: ButtonProps) {
    // If variant is outline or ghost, apply custom override
    const customClassName =
        variant === "outline" || variant === "ghost"
            ? customVariantOverrides[variant]
            : undefined;

    return (
        <BaseButton
            className={cn(
                // Remove base variant classes for outline/ghost and apply custom ones
                variant === "outline" || variant === "ghost"
                    ? customClassName
                    : undefined,
                className
            )}
            variant={variant}
            size={size}
            {...props}
        />
    );
}

export { Button };

